import React, { useId } from 'react'
import { useTranslation } from 'react-i18next';
import _uniqueId from 'lodash/uniqueId';
import flag_kor from "../images/flag_kor.png";
import flag_eng from "../images/flag_eng.png";
import flag_thai from "../images/flag_thai.png";
import flag_viet from "../images/flag_viet.png";
import { korTheme, engTheme, vietTheme,thaiTheme  } from '../theme/theme';


export function LanguageIcon() {
    
    const { t } = useTranslation();
    const lang = localStorage.getItem("language") || "ko";

    var imgLanguageLogSrc = flag_kor;
    
    if(lang==="ko"){
        return(<img src={flag_kor} alt={t(`Language.국가명`)}/>);
    
    }else if(lang==="en"){
        imgLanguageLogSrc = (<img src={flag_eng} alt={t(`Language.국가명`)}/>);
        
    }else if(lang==="th"){
        imgLanguageLogSrc = (<img src={flag_thai} alt={t(`Language.국가명`)}/>);
        
    }else if(lang==="vn"){
        imgLanguageLogSrc = (<img src={flag_viet} alt={t(`Language.국가명`)}/>);
        
    }

    return imgLanguageLogSrc;
}
//TODO 다국어
export function fn_processSttusCodeNm(code){
    let message = '';
    if(code === 'ODR001'){
        message = '주문'
    }else if(code === 'ODR002'){
        message = '결제대기'
    }else if(code === 'ODR003'){
        message = '배송준비'
    }else if(code === 'ODR004'){
        message = '배송중'
    }else if(code === 'ODR005'){
        message = '배송완료'
    }else if(code === 'ODR006'){
        message = '구매확정'
    }else if(code === 'ODR007'){
        message = '주문취소'
    }else if(code === 'ODR008'){
        message = '환불요청'
    }else if(code === 'ODR009'){
        message = '환불진행중'
    }else if(code === 'ODR010'){
        message = '환불완료'
    }else if(code === 'ODR011'){
        message = '결제대기시간 만료'
    }else if(code === 'ODR012'){
        message = '주문취소 요청중'
    }
    return message;
}


export function LanguageTheme() {
    
    const lang = localStorage.getItem("language") || "ko";

    if(lang==="ko"){
        return korTheme;    
    }else if(lang==="en"){
       return engTheme;    
        
    }else if(lang==="th"){
        return thaiTheme;    
        
    }else if(lang==="vn"){
        return vietTheme;    
    }

    return null
}

export function LanguageNm() {
    const { t } = useTranslation();    
    return t(`Language.국가명`);
}

export function getCartCookie(){
    const cartCookie = localStorage.getItem("cartCookie") || Date.now().toString(36);
    localStorage.setItem("cartCookie", cartCookie);
    return cartCookie;
}


export function splitIntoChunk(arr, chunk) {
    // 빈 배열 생성
    const result = [];
    
    for (var index=0; index < arr.length; index += chunk) {
      let tempArray;
      // slice() 메서드를 사용하여 특정 길이만큼 배열을 분리함
      tempArray = arr.slice(index, index + chunk);
      // 빈 배열에 특정 길이만큼 분리된 배열을 추가
      if(tempArray.length === chunk){
        result.push(tempArray);
      }
      
    }
    
    return result;
}

